import React from 'react';
import PropTypes from 'prop-types';

import { accessRowToFieldId } from '../helpers';

const buildGroupTotals = (group = [], formValues = {}) => {
  const totals = {
    readonly: 0,
    write: 0,
    preferences: 0,
  };

  group.forEach(item => {
    const Id = accessRowToFieldId(item);

    if (
      formValues[`AllowRead${Id}`] !== undefined &&
      formValues[`AllowRead${Id}`] &&
      item.IsViewOnlyApplicable
    ) {
      totals.readonly++;
    }

    if (
      formValues[`AllowWrite${Id}`] !== undefined &&
      formValues[`AllowWrite${Id}`]
    ) {
      totals.write++;
    }

    if (item.Preferences) {
      item.Preferences.forEach(preference => {
        const Id = accessRowToFieldId(preference);
        if (
          formValues[`AllowWrite${Id}`] !== undefined &&
          formValues[`AllowWrite${Id}`]
        ) {
          totals.preferences++;
        }
      });
    }
  });

  return totals;
};

const Summary = ({ group, formValues }) => {
  const { readonly, write, preferences } = buildGroupTotals(group, formValues);

  return (
    <div className="group-root--summary">
      <dl>
        <dt>Read Only</dt>
        <dd>{readonly}</dd>
        <dt>Write</dt>
        <dd>{write}</dd>
        <dt>Preferences</dt>
        <dd>{preferences}</dd>
      </dl>
    </div>
  );
};

Summary.propTypes = {
  formValues: PropTypes.object.isRequired,
  group: PropTypes.array.isRequired,
};

export { Summary };



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/components/Summary.js